<form
  (submit)="onSubmit($event)"
  [ngClass]="{
    collapsed: isCollapsible,
    'full-size': showInput,
    'no-background-with-border': noBackgroundWithBorder,
    'border-focus': showInputSearch && !platformService.isMobile(),
    'w-full': showInputSearch && platformService.isMobile(),
    'form-w-search': !showInputSearch,
    'light-gray-background':
      isLightGrayBackground && platformService.isMobile(),
  }"
  class="form-w"
>
  @if (showInputSearch) {
    <input
      class="no-clear-button"
      #inputElement
      [formControl]="query"
      [value]="query.value"
      type="search"
      [placeholder]="placeholder"
      (focus)="focusIn()"
      (keydown.enter)="onEnter($event)"
      (focusout)="focusout()"
      [ngClass]="{
        'full-size': showInput,
        show: !isCollapsible || showInput,
        'light-gray-background': isLightGrayBackground,
      }"
    />
  }

  <button (click)="focusInButton()" class="button-container" type="button">
    @if (showInputSearch && query.value.length > 0) {
      <i
        class="a-icon boschicon-bosch-ic-close icon-x"
        (click)="clearSearchBar()"
      ></i>
    }

    <i class="boschicon-bosch-ic-search"></i>
  </button>
</form>
